export default __webpack_public_path__ + "static/media/lzusdc.08c0eb79.webp";